/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper }  from "cms/fields/layout/field-display-wrapper";
import { useTranslation } from "react-i18next";

const EmbedBuilderFieldDisplay = () => {
    
    const { t } = useTranslation();
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {values &&
                values.length > 0 &&
                values.map((item) => {
                    const { value } = item || {};
                    return (
                        <iframe
                            key={value}
                            width='100%'
                            height='550px'
                            src={value}
                            title={t("commons.embedUrl")}
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                            allowFullScreen
                        ></iframe>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
EmbedBuilderFieldDisplay.displayName = "EmbedBuilderFieldDisplay";
export { EmbedBuilderFieldDisplay };
